import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownProps {
  variant?: 'inline' | 'boxes';
  tone?: 'light' | 'dark';
  className?: string;
}
export function Countdown({
  variant = 'boxes',
  tone = 'dark',
  className = ''
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  if (variant === 'inline') {
    return <span className={`font-sans font-bold tabular-nums ${className}`} data-id="element-26" data-mp="3pzknexk83610">
        {hours}:{minutes}:{seconds}
      </span>;
  }
  const boxClass = tone === 'dark' ? 'bg-violeta-profundo text-crema' : 'bg-white text-violeta-profundo border border-dorado/40';
  const items: Array<[string, string]> = [[hours, 'horas'], [minutes, 'min'], [seconds, 'seg']];
  return <div className={`flex items-center justify-center gap-2 sm:gap-3 ${className}`} aria-live="off" data-id="element-27" data-mp="374md4a2rnn84">
      {items.map(([value, label]) => <div key={label} className={`${boxClass} rounded-xl px-3 py-2 sm:px-4 sm:py-3 min-w-[68px] text-center shadow-sm`} data-id="element-28" data-mp="15boge35vcahw">
          <div className="text-2xl sm:text-3xl font-bold tabular-nums leading-none" data-id="element-29" data-mp="xytue8i8wn21">{value}</div>
          <div className="text-[10px] uppercase tracking-widest mt-1 opacity-70" data-id="element-30" data-mp="szzat4cgeugv">{label}</div>
        </div>)}
    </div>;
}